import { render, staticRenderFns } from "./DeleteAccount.vue?vue&type=template&id=4c7badfc"
import script from "./DeleteAccount.vue?vue&type=script&lang=ts"
export * from "./DeleteAccount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/apps/front/flightpath-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c7badfc')) {
      api.createRecord('4c7badfc', component.options)
    } else {
      api.reload('4c7badfc', component.options)
    }
    module.hot.accept("./DeleteAccount.vue?vue&type=template&id=4c7badfc", function () {
      api.rerender('4c7badfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DeleteAccount.vue"
export default component.exports